import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tag20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M14.9999 6C14.9999 6.55228 14.5522 7 13.9999 7C13.4476 7 12.9999 6.55228 12.9999 6C12.9999 5.44772 13.4476 5 13.9999 5C14.5522 5 14.9999 5.44772 14.9999 6Z'
      fill='currentColor'
    />
    <path
      d='M5.96954 11.0303L8.96954 14.0303L10.0302 12.9697L7.0302 9.96967L5.96954 11.0303Z'
      fill='currentColor'
    />
    <path
      d='M7.96954 8.03033L11.9695 12.0303L13.0302 10.9697L9.0302 6.96967L7.96954 8.03033Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.32315 1.61618C9.55757 1.38176 9.87551 1.25006 10.207 1.25006H17.4999C18.1903 1.25006 18.7499 1.80971 18.7499 2.50006V9.79295C18.7499 10.1245 18.6182 10.4424 18.3838 10.6768L9.88381 19.1768C9.39565 19.665 8.6042 19.665 8.11604 19.1768L0.823147 11.8839C0.334991 11.3958 0.334994 10.6043 0.823148 10.1162L9.32315 1.61618ZM10.3106 2.75006L2.06058 11.0001L8.99993 17.9394L17.2499 9.6894V2.75006H10.3106Z'
      fill='currentColor'
    />
  </Svg>
);

Tag20.displayName = 'Tag20';
export default Tag20;
